import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import ApplyModal from "../../components/ApplyModal";
import "../../components/ApplyModal.css";
import "./SchoolHeader.css";

const SchoolHeader = ({ schoolId = null }) => {
  const baseUrl = schoolId ? `/${schoolId}` : "/";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // ✅ store WHICH dropdown is open
  const [openDropdown, setOpenDropdown] = useState(null);
  const navbarRef = useRef(null);
  const togglerRef = useRef(null);
  /* ✅ CLOSE NAVBAR (BOOTSTRAP-SAFE) */
  const closeMobileMenu = () => {
    setOpenDropdown(null);

    if (window.innerWidth < 992 && togglerRef.current) {
      togglerRef.current.click(); // 🔥 closes collapse properly
    }
  };
  const toggleDropdown = (name) => {
    setOpenDropdown(prev => (prev === name ? null : name));
  };

  const goToAboutUsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/about`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToAcademicsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/academics`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToAdmissionsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/admissions`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToLifeAtTIGPSSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/life-at-tigps`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToContactSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/contact`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };


  const goToMandatoryDisclosure = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/mandatory-public-disclosure`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link className="navbar-brand" to={baseUrl || "/"} onClick={closeMobileMenu}>
            <img src="/pictures/tigps_logo.png" alt="TIGPS Logo" className="logo-img" />
          </Link>
          <button ref={togglerRef} className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto" style={{ marginRight: '10px' }}>
              <li className="nav-item">
                <Link className="nav-link" to={baseUrl || "/"} onClick={closeMobileMenu}>Home</Link>
              </li>

              {/* -------------- About us Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'about' ? 'open' : ''}`}
                onClick={() => toggleDropdown('about')}
              >
                <Link to={`${baseUrl}/about`} className="nav-link dropdown-toggle">About Us</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "about-us")} className="dropdown-item-custom">
                      Who We Are
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "affiliations-and-certifications")} className="dropdown-item-custom">
                      Affiliations and Certifications
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "our-programs-towards-the-society")} className="dropdown-item-custom">
                      Our Programmes towards the Society
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Academics Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'academics' ? 'open' : ''}`}
                onClick={() => toggleDropdown('academics')}
              >
                <Link to={`${baseUrl}/academics`} className="nav-link dropdown-toggle">Academics</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "question-bank")} className="dropdown-item-custom">
                      Question Bank
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "techno-aep")} className="dropdown-item-custom">
                      Techno AEP
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Admission Menu --------------- */}
              <li
                className={`nav-item dropdown ${openDropdown === 'admissions' ? 'open' : ''}`}
                onClick={() => toggleDropdown('admissions')}
              >
                <Link to={`${baseUrl}/admissions`} className="nav-link dropdown-toggle">Admissions</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "admission-overview")} className="dropdown-item-custom">
                      Admission Overview
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "admission-application-procedurer")} className="dropdown-item-custom">
                      Admission Procedure
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "criteria")} className="dropdown-item-custom">
                      Criteria
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "school-uniform")} className="dropdown-item-custom">
                      School Uniform
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Life at tigps Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'life' ? 'open' : ''}`}
                onClick={() => toggleDropdown('life')}
              >
                <Link to={`${baseUrl}/life-at-tigps`} className="nav-link dropdown-toggle">Life at TIGPS</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "beyond-academics")} className="dropdown-item-custom">
                      Beyond Academics
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "gallery")} className="dropdown-item-custom">
                      Life at {schoolId.toUpperCase().replace(/-/g, " - ")}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "videos")} className="dropdown-item-custom">
                      Videos
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "news-updates")} className="dropdown-item-custom">
                      News & Updates
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "celebratory-events")} className="dropdown-item-custom">
                      Celebratory Events
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "news-letter")} className="dropdown-item-custom">
                      Newsletter
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "techno-echo")} className="dropdown-item-custom">
                      Techno Echo
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "prospectus")} className="dropdown-item-custom">
                      Prospectus
                    </Link>
                  </li>
                </ul>

              </li>

              {/* -------------- Mandatory Disclosure Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'mandatory' ? 'open' : ''}`}
                onClick={() => toggleDropdown('mandatory')}
              >
                <Link to={`${baseUrl}/mandatory-public-disclosure`} className="nav-link dropdown-toggle">Mandatory Public Disclosure</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "general-information")} className="dropdown-item-custom">
                      General information
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "documents-information")} className="dropdown-item-custom">
                      Documents and Information
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "result-academics")} className="dropdown-item-custom">
                      Result and Academics
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "result-class-x")} className="dropdown-item-custom">
                      Result of class X
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "result-class-xii")} className="dropdown-item-custom">
                      Result of class XII
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "staff-information")} className="dropdown-item-custom">
                      Staff Information
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToMandatoryDisclosure(e, "infrastructure-information")} className="dropdown-item-custom">
                      School Infrastructure Information
                    </Link>
                  </li>
                </ul>

              </li>

              {/* -------------- Contact us Menu --------------- */}

              <li className="nav-item">
                <Link className="nav-link" to={`${baseUrl}/contact`} onClick={closeMobileMenu}>Contact Us</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to={"https://careers.tigps.in/"} onClick={closeMobileMenu} target="_blank">Career</Link>
              </li>

            </ul>
            <div className="apply-btn-wrapper">
              <button className="btn apply-btn" onClick={() => setIsModalOpen(true)}>Apply Now</button>
            </div>
          </div>
        </div>
      </nav>
      <ApplyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
};

export default SchoolHeader;
